import { makeAutoObservable } from 'mobx'
import { FormEvent } from 'react'
import { openApi } from '../../../helpers/request'
import userController from '../../user/controllers/user.controller'
import i from '../../../translations/i'
import { notification } from 'antd'

class settingsController {

    project = {
      ordercomment: '',
      deliveryattributes: 0,
      ordering: 0,
      ordering_description: '',
      cutlery: 0,
      cutlery_description: '',
      productcount: 0
    }

    constructor() {
        makeAutoObservable(this)
    }

    getProject() {
        openApi('get', '/settings')
          .then(result => {
              console.log(result)
              this.project.ordercomment = result.data.ordercomment
              this.project.deliveryattributes = result.data.deliveryattributes
              this.project.ordering = result.data.ordering
              this.project.ordering_description = result.data.ordering_description
              this.project.cutlery = result.data.cutlery
              this.project.cutlery_description = result.data.cutlery_description
              this.project.productcount = result.data.productcount

          })
          .catch(err => console.log(err))
    }

    onChangeProject(name: string, value: any) {
        // @ts-ignore
        this.project[name] = value
    }

    save(e: FormEvent) {
        e.preventDefault()

        let data = new FormData()

        data.append('ordercomment', `${this.project.ordercomment}`)
        data.append('deliveryattributes', `${+ this.project.deliveryattributes}`)
        data.append('ordering', `${+ this.project.ordering}`)
        data.append('ordering_description', `${this.project.ordering_description}`)
        data.append('cutlery', `${+ this.project.cutlery}`)
        data.append('cutlery_description', `${this.project.cutlery_description}`)
        data.append('productcount', `${+ this.project.productcount}`)

        openApi('post', '/setting/edit', data)
            .then(result => {
              console.log(result)
                userController.encrypt('project', result.data)
                notification.success({
                    message: i.t('def:success.complete')
                })
            })
            .catch(result => {
                console.log(result.response.data)
            })
    }
}

export default new settingsController()